import actions from './actions';
import types from './constants';
import services from '../../services/tracking';

const trackingSelect = (selection) => (dispatch) => {
  dispatch(actions[types.TRACKING_SELECT](selection));
};

const trackingSort = (sort) => (dispatch) => {
  dispatch(actions[types.TRACKING_SORT](sort));
};

const fetchReport = (schoolId, students, screeningWindow, selectedDistrict, params={}) => async (dispatch) => {
  const {skipPending = false} = params
  if (!skipPending) dispatch(actions[types.TRACKING_PENDING]())
  try {
    let districtId = selectedDistrict ? selectedDistrict.value : null;
    const reportData = await services.getReport(schoolId, students, screeningWindow,districtId)
    dispatch(actions[types.TRACKING_COMPLETE]({data: reportData}));
  }
  catch (e) {
    console.log("ERROR:",e);
    dispatch(actions[types.TRACKING_ERROR](e))
  }
};

export default {
  trackingSelect,
  trackingSort,
  fetchReport,
};
